// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const prefixwrap = (userOptions) => {
    const prefix = `.${userOptions.wrapperClassName} `;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function onProcessStyle(style, rule) {
        for (const prop in style) {
            if (prop === Object.keys(style)[0]) {
                const parent = rule.options.parent;
                if ([rule.type === 'style' || (parent && parent.type !== 'keyframes')] && rule.selectorText.indexOf(prefix) !== 0) {
                    rule.selectorText = prefix + rule.selectorText;
                }
            }
        }
        return style;
    }
    return { onProcessStyle: onProcessStyle };
};
